export default {
    fetchAndActivate: async () => false,
    getString: () => '',
    getBoolean: () => false,
    setDefaults: async () => {},
    setConfigSettings: async () => {},
  };